import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

import {withStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const styles = (theme) => {
    return {
        root: {
            width: '100%',
            height: 68,
        },
        formLabelRoot: {
            fontSize: 13,
            '&$formLabelFocused:not($formLabelError)': {
                color: theme.palette.secondary.main,
            }
        },
        formLabelFocused: {},
        formLabelError: {},
        inputTextField: {
            zIndex: 1,
        },
        inputUnderline: {
            '&:hover:not($inputDisabled):not($inputFocused):not($inputError):before': {
                borderBottomWidth: 1,
                borderBottomStyle: 'solid',
                borderBottomColor: 'rgba(0, 0, 0, 0.42)',
            },
            '&:before': {
                borderBottomWidth: 1,
                borderBottomStyle: 'solid',
                borderBottomColor: 'rgba(0, 0, 0, 0.42)',
            },
            '&:after': {
                borderBottomWidth: 2,
                borderBottomStyle: 'solid',
                borderBottomColor: theme.palette.secondary.main,
            },
        },
        inputError: {},
        inputFocused: {},
        inputDisabled: {},
    };
}

class InputField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: '',
        };

        this._value = (this.props.value) ? this.props.value : '';
    }

    render = () => {
        const {classes} = this.props;

        const inputLabelProps = {
            FormLabelClasses: {
                root: classes.formLabelRoot,
                focused: classes.formLabelFocused,
                error: classes.formLabelError,
            }
        }

        const inputProps = {
            classes: {
                underline: classes.inputUnderline,
                error: classes.inputError,
                focused: classes.inputFocused,
                disabled: classes.inputDisabled,
            }
        }

        return (
            <div className={classNames(classes.root, this.props.className)}>
                <TextField
                    className={classes.inputTextField}
                    fullWidth={true}
                    margin='dense'
                    id={this.props.id}
                    label={this.props.label}
                    helperText={this.state.error}
                    type={this.props.type}
                    autoFocus={this.props.autoFocus}
                    disabled={this.props.disabled}
                    onChange={this._handleTextField}
                    error={!!this.state.error}
                    InputLabelProps={inputLabelProps}
                    InputProps={inputProps}
                    value={this._value}
                />
            </div>
        );
    }

    value = () => {
        return this._value;
    }

    validate = () => {
        if (this.props.onValidate) {
            const result = this.props.onValidate(this.props.id, this._value);

            this.setState({error: result});

            return (!result) ? true : false;
        }

        return true;
    }

    _handleTextField = (event) => {
        this.setState({error: ''});
        this._value = event.target.value;
    }
}

InputField.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    type: PropTypes.string,
    autoFocus: PropTypes.bool,
    disabled: PropTypes.bool,
    onValidate: PropTypes.func,
}

export default withStyles(styles)(InputField);
